import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarTipoAcumulado from "./AgregarTipoAcumulado/AgregarTipoAcumulado";
import EditarTipoAcumulado from "./EditarTipoAcumulado/EditarTipoAcumulado";

moment.locale("es");

const TIPO_ACUMULADO_LABELS = {
  1: "Percepción, Deducción y Obligación",
  2: "Días y Horas",
};

class TiposAcumulados extends Component {
  tableRef = null;
  state = {
    todosTiposAcumulados: [],
    loading: false,
    valor: 1,
    modalAgregarTipoAcumulado: false,
    modalEditarTipoAcumulado: false,
    modalEditarTipoAcumuladoId: null,
  };

  consultarTiposAcumulados(params) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposAcumulados/selectTodasTiposAcumulados",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosTiposAcumulados: [] });
        } else {
          this.setState({
            todosTiposAcumulados: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  deshabilitarTipoAcumulado(value) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposAcumulados/deshabilitarTipoAcumulado",
        { tipoAcumuladoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de acumulado deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  habilitarTipoAcumulado(value) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposAcumulados/habilitarTipoAcumulado",
        { tipoAcumuladoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de acumulado habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  agregarTipoAcumulado() {
    this.setState({ modalAgregarTipoAcumulado: true });
  }

  cerrarAgregarTipoAcumulado() {
    this.setState({ modalAgregarTipoAcumulado: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarTipoAcumulado(id) {
    this.setState({ modalEditarTipoAcumulado: true, modalEditarTipoAcumuladoId: id });
  }

  cerrarEditarTipoAcumulado() {
    this.setState({ modalEditarTipoAcumulado: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        width: "18%",
      },
      {
        title: "Tipo Acumulado",
        dataIndex: "tipoAcumulado",
        key: "tipoAcumulado",
        width: "20%",
        render: (value) => TIPO_ACUMULADO_LABELS[value] || "—",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          if (value === 0) return <Tag color="red">Cancelado</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "10%",
        render: (value, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip
              key={`tooltip-editar-${record._id}`}
              title="Editar Tipo de Acumulado"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarTipoAcumulado(record._id)}
              />
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este tipo de acumulado?"
                onConfirm={() => this.deshabilitarTipoAcumulado(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este tipo de acumulado?"
                onConfirm={() => this.habilitarTipoAcumulado(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Tipos de Acumulados"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Vigente", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem
                type="primary"
                key="agregarTipoAcumulado"
                onClick={this.agregarTipoAcumulado.bind(this)}
              >
                Agregar Tipo de Acumulado
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarTiposAcumulados.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosTiposAcumulados}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"tiposAcumulados" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              this.editarTipoAcumulado(record._id);
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarTipoAcumulado
          visible={this.state.modalAgregarTipoAcumulado}
          cerrarAgregarTipoAcumulado={this.cerrarAgregarTipoAcumulado.bind(this)}
        />
        <EditarTipoAcumulado
          visible={this.state.modalEditarTipoAcumulado}
          tipoAcumuladoId={this.state.modalEditarTipoAcumuladoId}
          cerrarEditarTipoAcumulado={this.cerrarEditarTipoAcumulado.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(TiposAcumulados);